import api from './client'

export interface UserItem {
  id: number
  email: string
  user_name: string
  first_name: string | null
  last_name: string | null
  avatar: string | null
  role: string
  is_active: boolean
  is_verified: boolean
  phone: string | null
  timezone: string
  subscription_status: string
  plan_code: string
  xp_total: number
  target_score_rw: number | null
  target_score_math: number | null
  sat_date: string | null
  onboarding_completed: boolean
  subscription_end_date: string | null
  create_datetime: string | null
}

export interface UserListResponse {
  items: UserItem[]
  total: number
}

export interface UserListParams {
  search?: string
  is_active?: boolean
  role?: string
  skip?: number
  limit?: number
}

export interface CreateUserPayload {
  email: string
  password: string
  user_name: string
  first_name?: string
  last_name?: string
  role: string
  phone?: string
  timezone?: string
  is_active: boolean
  is_verified: boolean
  plan_code?: string
  subscription_end_date?: string
}

export interface UpdateUserPayload {
  email?: string
  password?: string
  user_name?: string
  first_name?: string
  last_name?: string
  role?: string
  phone?: string
  timezone?: string
  is_active?: boolean
  is_verified?: boolean
  plan_code?: string
  onboarding_completed?: boolean
  subscription_end_date?: string
}

export interface UnlockSessionResponse {
  ended_count: number
  message: string
}

export const usersApi = {
  list: (params: UserListParams) => api.get<UserListResponse>('/users', { params }),
  create: (data: CreateUserPayload) => api.post<UserItem>('/users', data),
  update: (userId: number, data: UpdateUserPayload) => api.put<UserItem>(`/users/${userId}`, data),
  delete: (userId: number) => api.delete(`/users/${userId}`),
  unlockSession: (userId: number) =>
    api.post<UnlockSessionResponse>(`/users/${userId}/unlock-session`),
}
